import React from 'react';
import { Helmet } from 'react-helmet-async';
import LegalPageLayout from './LegalPageLayout';

const PrivacyPage = () => (
  <LegalPageLayout title="Politika zasebnosti" eyebrow="Pravno obvestilo" testid="privacy-page">
    <Helmet>
      <title>Politika zasebnosti – Val Dotika</title>
      <meta name="description" content="Politika zasebnosti društva Val Dotika. Skladno z GDPR in ZVOP-2." />
    </Helmet>

    <p>
      V društvu Val Dotika spoštujemo vašo zasebnost v skladu z uredbo GDPR in ZVOP-2. Upravljavec vaših podatkov je Društvo Val Dotika, Ulica heroja Marinclja 6, Kočevje (<a href="mailto:info@valdotika.si" className="text-violet-900 font-semibold hover:underline">info@valdotika.si</a>).
    </p>

    <p>
      Zbiramo le podatke, ki nam jih posredujete prostovoljno ob prijavi (ime, priimek, elektronski naslov, telefonska številka).
    </p>

    <p>
      Podatke uporabljamo izključno za namen organizacije tečajev, obveščanja o podrobnostih delavnice in komunikacije v primeru sprememb termina.
    </p>

    <p>
      Podatke, povezane z izvedbo delavnic, hranimo največ 1 leto po izvedbi dogodka, razen kadar zakon določa daljše roke. Kontaktne podatke za namene obveščanja hranimo do vašega preklica.
    </p>

    <p>
      Vaših podatkov ne posredujemo tretjim osebam, razen kadar je to nujno za izpolnjevanje zakonskih obveznosti.
    </p>

    <p>
      Kadarkoli lahko zahtevate vpogled, popravek ali trajen izbris svojih podatkov iz naše baze tako, da nam pišete na naš kontaktni naslov.
    </p>
  </LegalPageLayout>
);

export default PrivacyPage;
